// extracted by mini-css-extract-plugin
export default {"Hint":"TvPZfDpFT13HYC7EmSnB","text":"ZNocPJswBoDRwaK1X9Aw"};